import axios from 'axios';
import { saveAs } from 'file-saver';
import * as R from 'ramda';
import { requestWithAuthorization } from '@/appsync/lambda/requestWithAuthorization';
import portalConfigure from '@/portal-configure';
import { ErrorInfo } from '@/types/type';

export const getPreSignedUrlForDownloadingIFXAPFile = async (
  scheduledEventHistoryId: string
): Promise<string> => {
  const response = await requestWithAuthorization
    .post(`${portalConfigure.API.generateDownloadLinkForIFXAPFiles}`, {
      scheduledEventHistoryId,
    })
    .catch(error => {
      const data = R.path(['response', 'data'], error);
      if (data) {
        error.message = JSON.stringify(data);
      } else {
        const errorInfo: ErrorInfo = {
          code: 'E00009',
          title: 'Error in downloading files from COMPANY V8.',
          message: error.message,
        };
        error.message = JSON.stringify(errorInfo);
      }
      throw error;
    });

  return response.data as string;
};

export const downloadFromPreSignedUrl = async (url: string) => {
  try {
    const response = await axios.get(url, { responseType: 'blob' });
    const blob = new Blob([response.data], {
      type: 'application/octet-stream',
    });
    saveAs(blob, 'output.zip');
  } catch (error) {
    const errorInfo: ErrorInfo = {
      code: 'E00009',
      title: 'Error in downloading files from COMPANY V8.',
      message: error.message,
    };
    error.message = JSON.stringify(errorInfo);
    throw error;
  }
};
